import { queryOptions, useQuery } from '@tanstack/react-query';

import { QueryRefetchInterval } from '@cast/shared-types';
import { CustomMetricsDataSource } from '@cast/types';
import { makeIsEnabled } from '@cast/utils';

import { apiClient } from '@cast/infrastructure-api';

const WOOP_CUSTOM_METRICS_DATA_SOURCES_QUERY_KEY =
  'woop-custom-metrics-data-sources';

export const getCustomMetricsDataSourcesQueryKey = (clusterId?: string) =>
  [WOOP_CUSTOM_METRICS_DATA_SOURCES_QUERY_KEY, clusterId] as const;

type Args = {
  clusterId: string;
  enabled?: boolean;
  refetchInterval?: QueryRefetchInterval<CustomMetricsDataSource[]>;
};

const getCustomMetricsDataSourcesQueryOptions = ({
  clusterId,
  enabled,
  refetchInterval,
}: Args) =>
  queryOptions({
    queryKey: getCustomMetricsDataSourcesQueryKey(clusterId),
    queryFn: async () => {
      const { data } =
        await apiClient.workloadOptimization.getCustomMetricsDataSources({
          clusterId,
        });
      return data.items;
    },
    enabled: makeIsEnabled(enabled, !!clusterId),
    refetchInterval,
  });

export const useCustomMetricsDataSourcesQuery = (args: Args) => {
  const { isLoading, data, error, refetch, isPending } = useQuery(
    getCustomMetricsDataSourcesQueryOptions(args)
  );

  return { isLoading, error, refetch, dataSources: data, isPending };
};
